var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white","width":"100%"}},[_c('div',{staticStyle:{"padding":"20px 15px","font-size":"14px"}},[_c('div',{staticStyle:{"color":"#999999"}},[_vm._v(_vm._s(_vm.info.createTime))]),_c('div',[_vm._v(_vm._s(_vm.info.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }